import React from 'react';
import { Div } from '../element';
import {
  PRODUCT_ID_CLOUD,
  CONNECT_TO_VCENTER,
  HPE_SIMPLIVITY,
  RACK_CHECKER,
  CABEL_CHECKER,
  UNBOX_CHECKER,
  UNBOX_FACTORY,
  UNBOX_FIELD,
  CABEL_CONNECT,
  PAGENAME_CABLE_SIMPLIVITY325,
  RACK_SWITCHED,
  CABLE_SWITCHED,
  RACK_SWITCHED_NOCABLETRAY,
} from '../../constants';
export const Wizard = ({ steps, path, step, element, text, queryString, stepsobj, wizardpage, wizardPageModel }) => {
  if (!steps || (Array.isArray(steps) && steps.length === 0)) return null;
  if (!Array.isArray(steps)) {
    window.location.reload();
  }
  const currentStep = step - 1;
  let cls = '';
  const classForCloudenablementPage =
    wizardpage === PRODUCT_ID_CLOUD ||
    wizardpage === CONNECT_TO_VCENTER ||
    wizardpage === RACK_SWITCHED ||
    wizardpage === RACK_SWITCHED_NOCABLETRAY
      ? 'cloudenablement'
      : '';
  const classForRackPage =
    wizardpage === RACK_SWITCHED || wizardpage === RACK_SWITCHED_NOCABLETRAY ? 'rackSwitchedPage' : '';
  const classForSimplivity = wizardpage === PRODUCT_ID_CLOUD && wizardPageModel === HPE_SIMPLIVITY ? 'svtcloud' : '';
  return (
    <Div className={`wizard horizontal ${classForCloudenablementPage}`}>
      <Div className="steps-row setup-panel">
        {steps.map((item, i) => {
          let style = 'incomplete',
            status = 'inactive';
          if (currentStep === i) {
            status = 'active';
          } else if (currentStep > i) {
            style = 'complete';
            status = 'completed';
          }
          if (
            (wizardpage === PRODUCT_ID_CLOUD ||
              wizardpage === CONNECT_TO_VCENTER ||
              wizardpage === CABEL_CONNECT ||
              wizardpage === UNBOX_CHECKER ||
              wizardpage === UNBOX_FACTORY ||
              wizardpage === UNBOX_FIELD ||
              wizardpage === RACK_CHECKER ||
              wizardpage === RACK_SWITCHED ||
              wizardpage === RACK_SWITCHED_NOCABLETRAY ||
              wizardpage === CABEL_CHECKER ||
              wizardpage === CABLE_SWITCHED ||
              wizardpage === PAGENAME_CABLE_SIMPLIVITY325) &&
            stepsobj.length > 0 &&
            'steptitle' in stepsobj[i]
          ) {
            cls = 'center';
          }
          return (
            <Div
              key={`rackInstellStep${i}`}
              className={`steps-step ${style} ${classForSimplivity} ${cls} ${classForRackPage}`}>
              {React.cloneElement(element, {
                text: `${text} ${i + 1}`,
                path: `${path}/${i + 1}`,
                status: status,
                queryString,
                steptitle:
                  (wizardpage === PRODUCT_ID_CLOUD ||
                    wizardpage === CONNECT_TO_VCENTER ||
                    wizardpage === RACK_CHECKER ||
                    wizardpage === RACK_SWITCHED ||
                    wizardpage === RACK_SWITCHED_NOCABLETRAY ||
                    wizardpage === CABEL_CONNECT ||
                    wizardpage === UNBOX_CHECKER ||
                    wizardpage === UNBOX_FACTORY ||
                    wizardpage === UNBOX_FIELD ||
                    wizardpage === CABEL_CHECKER ||
                    wizardpage === CABLE_SWITCHED ||
                    wizardpage === PAGENAME_CABLE_SIMPLIVITY325) &&
                  stepsobj.length > 0 &&
                  'steptitle' in stepsobj[i]
                    ? stepsobj[i].steptitle
                    : '',
              })}
            </Div>
          );
        })}
      </Div>
    </Div>
  );
};
